/**
 * @generated SignedSource<<cd3f637165d8edb42cd4ec68245b2025>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageSettingsSmallImage_image$data = {
  readonly id: string;
  readonly smallImage: {
    readonly url: string;
  } | null;
  readonly " $fragmentType": "PageSettingsSmallImage_image";
};
export type PageSettingsSmallImage_image$key = {
  readonly " $data"?: PageSettingsSmallImage_image$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageSettingsSmallImage_image">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSettingsSmallImage_image",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "smallImage",
      "args": [
        {
          "kind": "Literal",
          "name": "minHeight",
          "value": 100
        },
        {
          "kind": "Literal",
          "name": "minWidth",
          "value": 100
        }
      ],
      "concreteType": "ImageSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": "size(minHeight:100,minWidth:100)"
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "3a216c8a3263da143e35d9119975273b";

export default node;
